@if (message) {
<div
  class="pia-modalBlock open"
  [id]="message.data && message.data.modal_id ? message.data.modal_id : null"
>
  <div class="pia-modalBlock-content">
    @if (!message.data || (message.data && !message.data.no_cross_button)) {
    <button
      tabindex="3"
      type="button"
      class="pia-modalBlock-close btn"
      (click)="message.noFn()"
      title="{{ 'modals.close' | translate }}"
    >
      <span class="pia-icons pia-icon-close-big"></span>
    </button>
    } @if (message.data && message.data.date) {
    <p
      [innerHTML]="
        message.text
          | translate
            : {
                date:
                  message.data.date
                  | date: 'short':'':languagesService.selectedLanguage
              }
      "
    ></p>
    } @else {
    <p [innerHTML]="message.text | translate"></p>
    } @if (message.data && message.data.additional_text) {
    <div
      class="abandonText"
      [innerHTML]="message.data.additional_text | translate"
    ></div>
    } @if (message.class) {
    <p>
      @if (message.icon === 'faPenToSquare') {
      <fa-icon [icon]="faPenToSquare" [ngClass]="message.class"></fa-icon>
      } @if (message.icon === 'faGear') {
      <fa-icon [icon]="faGear" [ngClass]="message.class"></fa-icon>
      } @if (message.icon === 'faXmark') {
      <fa-icon [icon]="faXmark" [ngClass]="message.class"></fa-icon>
      } @if (message.icon === 'faCheck') {
      <fa-icon [icon]="faCheck" [ngClass]="message.class"></fa-icon>
      }
    </p>
    } @else {
    <p>
      <i [ngClass]="message.icon" aria-hidden="true"></i>
    </p>
    }
    <div class="pia-modalBlock-buttons-choice">
      @if (message.type != 'others') { @if (message.type === 'confirm') {
      <button
        tabindex="2"
        style="margin-right: 30px;"
        class="btn"
        [ngClass]="
          message.data && message.data.btn_no ? message.data.btn_no : 'btn-red'
        "
        (click)="message.noFn()"
        type="button"
        [innerHtml]="message.no | translate"
      ></button>
      } @if (message.yes) {
      <button
        tabindex="1"
        class="btn"
        [ngClass]="
          message.data && message.data.btn_yes
            ? message.data.btn_yes
            : 'btn-green'
        "
        type="button"
        (click)="message.yesFn()"
        [innerHtml]="message.yes | translate"
      ></button>
      } } @else { @for (btn of message.othersActionsBtn; track btn) {
      <button
        tabindex="2"
        style="margin-right: 30px;"
        class="btn"
        (click)="btn.callback()"
        type="button"
        [innerHtml]="btn.label | translate"
      ></button>
      } }
    </div>
  </div>
</div>
}
